import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import { HanddrawnArrow } from './HanddrawnArrow'
import { ArcOrbitButton } from './ArcOrbitButton'

export default function FloatingNotice() {
  const [isMinimized, setIsMinimized] = useState(true)

  if (isMinimized) {
    return (
      <aside
        aria-label="Meddelelse om ledige pladser"
        className="fixed bottom-4 right-4 sm:bottom-6 sm:right-6 z-40 animate-fadeIn"
      >
        <ArcOrbitButton
          as="button"
          type="button"
          onClick={() => setIsMinimized(false)}
          size="sm"
          className="shadow-xl"
          icon={<i className="fa-solid fa-graduation-cap text-xs text-white/90" aria-hidden="true" />}
        >
          Ledige pladser 2026/27
        </ArcOrbitButton>
      </aside>
    )
  }

  return (
    <aside
      aria-label="Meddelelse om ledige pladser"
      className="fixed bottom-4 right-4 sm:bottom-6 sm:right-6 z-40 w-[calc(100vw-2rem)] sm:w-[420px] max-w-full animate-fadeIn"
    >
      <div className="bg-white text-[#36454F] border border-[#DCEEF2] rounded-3xl shadow-2xl p-5 sm:p-6 relative">
        {/* Header with Minimize Button */}
        <div className="flex items-center justify-between mb-2">
          <span className="font-['Shadows_Into_Light'] text-2xl text-[#007A53] leading-none">
            Optagelse
          </span>
          <button
            type="button"
            onClick={() => setIsMinimized(true)}
            className="text-stone-400 hover:text-[#36454F] p-1 transition-colors focus:outline-none rounded cursor-pointer"
            aria-label="Minimer boks"
            title="Minimer"
          >
            <i className="fa-solid fa-xmark text-base" aria-hidden="true" />
          </button>
        </div>

        {/* Text Content */}
        <div className="space-y-2.5 text-[#36454F]/90 text-sm leading-relaxed">
          <h4 className="font-['Plus_Jakarta_Sans'] font-black text-[#36454F] text-lg leading-tight">
            Ledige pladser 2026/2027
          </h4>
          <p>
            Vi har fortsat ledige pladser i 8., 9. og 10. klasse i skoleåret 2026-2027. Så er du ordblind? Og drømmer du om et år med fællesskab og store oplevelser? ⚽🎨🎮🎸🛠️🛶
          </p>
          <p className="font-medium text-[#36454F] pt-0.5">
            Så kontakt os endelig på{' '}
            <a
              href="tel:74724433"
              className="text-[#007A53] font-bold hover:underline underline-offset-4 transition-colors inline-flex items-center gap-1.5"
            >
              <i className="fa-solid fa-phone text-xs" aria-hidden="true" />
              <span>74 72 44 33</span>
            </a>
            .
          </p>
        </div>

        {/* Action Buttons */}
        <div className="mt-5 pt-4 border-t border-[#DCEEF2] flex flex-wrap items-center gap-3">
          <a
            href="tel:74724433"
            className="organic-btn organic-btn--secondary !min-h-0 !py-3 !px-5 !text-xs inline-flex items-center gap-2 shadow-sm"
          >
            <i className="fa-solid fa-phone text-xs" aria-hidden="true" />
            <span>74 72 44 33</span>
          </a>

          <ArcOrbitButton
            to="/rundvisning"
            icon={<i className="fa-solid fa-calendar-check text-xs" aria-hidden="true" />}
            arrow={false}
            className="!min-h-[46px]"
          >
            Book rundvisning
          </ArcOrbitButton>
        </div>
      </div>
    </aside>
  )
}
